class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsFound = [];
    this.outputList = this.querySelector('ul');
  }

  selfDestruct() {
    this.dispatchEvent(new CustomEvent('cart:upsell:empty'));

    this.removeAttribute('data-loaded');
    var cartDrawer = this.closest('cart-drawer');
    if (cartDrawer && cartDrawer.querySelector('.cart__rec')) {
        cartDrawer.querySelector('.cart__rec').remove();
    }
  }

  buildCartIdList() {
    this.cartItems = this.getAttribute('cart-items');
    
    if (this.cartItems && this.cartItems.length > 0) {
      this.cartItems = this.cartItems.split(',');
    };

    if (!this.cartItems) {
      this.selfDestruct();
      return;
    }
  }

  async fetchRecommendations() {
    if (this.cartItems.length == 0) { return; }
    
    var section_id = this.getAttribute('section');
    var baseUrl = this.getAttribute('data-section-url');
    var idParam = "&product_id=" + this.cartItems[0];
  
    var res = await fetch(baseUrl + "&sections=" + section_id + idParam)
    .then(res => res.json())
    .then((json) => {
        var items = json[section_id];
        var parsed_dom = new DOMParser().parseFromString(items, "text/html");
        this.cartItems.shift();
        return parsed_dom;
    });

   return res;
  }

  getRecommendations() { 
    this.fetchRecommendations()
      .then((results) => {
        if (results && results.querySelector('.shopify-section li')) {
          results.querySelectorAll('.shopify-section li').forEach((elem) => {
            this.recommendationsFound.push(elem);
            this.outputList.appendChild(elem);
          });

          this.setAttribute('data-loaded', '');
          return this.recommendationsFound;
        }
        
        return false;
      }).then((matches) => {
        if (!matches) {
          this.selfDestruct();
        }

    });
  }

            
  connectedCallback() {
    this.buildCartIdList();
    this.getRecommendations();
  }
}


customElements.define('cart-recommendations', CartRecommendations);